<script lang="ts">
    import { assets as assetPath } from "$app/paths"
    import FooterList from "../elements/FooterList.svelte";
    const listOne = [
        {text: "Find a job", url: "https://www.offerzen.com/software-engineer-jobs"},
        {text: "FAQs", url: "http://docs.offerzen.com/en/collections/111174-candidate-faq-s"},
        {text: "Guides", url: "http://docs.offerzen.com/en/collections/111151-candidate-guides"},
        {text: "Community", url: "https://www.offerzen.com/community"},
        {text: "Companies on OfferZen", url: "https://www.offerzen.com/companies/public_list"}
    ]

    const listTwo = [
        {text: "Hire developers", url: "https://www.offerzen.com/hire-developers"},
        {text: "Browse developers", url: "https://www.offerzen.com/employers/find-developers"},
        {text: "FAQs", url: "http://docs.offerzen.com/en/collections/111166-company-faq-s"},
        {text: "Guides", url: "http://docs.offerzen.com/en/collections/111160-company-guides"},
        {text: "Product features", url: "https://www.offerzen.com/hire-developers/product-features"},
        {text: "Partner Services", url: "https://www.offerzen.com/partners"},
        {text: "Case studies", url: "https://www.offerzen.com/hire-developers/case-studies"},
        {text: "Product demo", url: "https://www.offerzen.com/hire-developers/product-video"}
    ]

    const listThree = [
        {text: "Meet the team", url: "https://www.offerzen.com/team"},
        {text: "Careers", url: "https://www.offerzen.com/careers"},
        {text: "Blog", url: "https://www.offerzen.com/blog"},
        {text: "Get swag", url: "https://www.offerzen.com/community/swag"},
        {text: "Netherlands Dev Report", url: "https://www.offerzen.com/reports/software-developer-netherlands"},
        {text: " South Africa Dev Report", url: "https://www.offerzen.com/reports/software-developer-south-africa"},
    ]
</script>
<footer>
    <div class="footer__primary">
        <img src={`${assetPath}/assets/offerzen_footer.svg`} alt="Grey Offerzen logo" />
        <FooterList
            list={listOne}
            heading="Developers"
        />
        <FooterList
            list={listTwo}
            heading="Employers"
        />
        <FooterList
            list={listThree}
            heading="OfferZen"
        />
        <FooterList
            list={listThree}
            heading="Social"
            social={true}
        />
    </div>
    <div class="footer__terms">
        <a href="https://www.offerzen.com/terms/" data-sveltekit-reload>Terms</a>
        <a href="https://www.offerzen.com/code_of_conduct/" data-sveltekit-reload>Code of Conduct</a>
        <a href="https://www.offerzen.com/privacy-centre/" data-sveltekit-reload>Privacy Centre</a>
    </div>
</footer>
<style lang="postcss">
    @import '../../styles/_mixins.css';
    footer {

        & img {
            align-self: flex-start;
        }

        & .footer__primary {
            display: flex;
            justify-content: center;
            gap:70px;
            padding:40px 0 100px;

            @mixin screen-md {
                padding:40px;
                gap:40px;
                flex-direction:column;
            }

            @mixin screen-sm {
                padding-left:24px;
                gap:35px;
            }
        }

        & .footer__terms {
            display: flex;
            justify-content: center;
            padding:40px;
            gap:50px;
            background-color: var(--color_grey_secondary);
            position: relative;

            @mixin screen-sm {
                background-color: var(--color_white);
                border:solid;
                border-width: 1px 0 0;
                border-color: var(--color_grey_secondary);
                padding-left:24px;
                gap:10px;
            }

            & a {
                text-decoration: none;
                color: var(--color_grey_tertiary);
                font-size:16px;
            }

            &::before {
                content: url('/assets/footerDino.svg');
                position: absolute;
                left:20%;
                top:-55%;

                @mixin screen-sm {
                    top:-59%;
                    left:80%;
                }
            }
        }
    }
</style>